// extracted by mini-css-extract-plugin
export default {"quote-container":"Quote_quote-container__N65nS"};